const routes = [
    {
        path: '/lbsmem',
        name: 'LbsMemeber',
        component: () => import(/* webpackChunkName: "lbs" */ '@/views/lbs/LbsMemberList'),
        meta: {
            step: ['위치관리시스템', '접근권한 리스트']
        }
    },
    {
        path: '/lbsterm',
        name: 'LbsTerm',
        component: () => import(/* webpackChunkName: "lbs" */ '@/views/lbs/LbsTermList'),
        meta: {
            step: ['위치관리시스템', '수집사실 확인 리스트']
        }
    },
    {
        path: '/lbslog',
        name: 'LbsLog',
        component: () => import(/* webpackChunkName: "lbs" */ '@/views/lbs/LbsLogList'),
        meta: {
            step: ['위치관리시스템', '접속기록 리스트']
        }
    },

]

export default routes
